import { useState, useCallback } from 'react';


export default function useSSIDList() {
    const [connectedSSIDInfo, setConnectedSSIDInfo] = useState({
        remembered_password: undefined,
        name: undefined,
        error: undefined,
    })

    const onSSIDRelatedEvent = useCallback((message) => {
        if (message.ev === "ssid_list") {
            let newSSIDs = message.msg.ssids.map((ssid) => {
                return {...ssid, };
            })

            let csl = newSSIDs.filter(ssid => ssid.connected === true);

            if (csl && csl.length > 0) { // at least one is connected
                setConnectedSSIDInfo({
                    remembered_password: csl[0].remembered_password,
                    name: csl[0].name,
                    error: undefined,
                });
            } else {
                setConnectedSSIDInfo({
                    remembered_password: undefined,
                    name: undefined,
                    error: undefined,
                });
            }
        } else if (message.ev === "connected_ssid"){
            setConnectedSSIDInfo({
                remembered_password: message.msg.remembered_password,
                name: message.msg.name,
                error: message.msg.error,
                // we should store `bssid` and `password` from here, when we decide to publish webview-based clients.
            });
        }        
    },[])

    return [connectedSSIDInfo, onSSIDRelatedEvent]
}
